import { REQUEST_TWITTER_POST_SUCCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function getTwitterPosts(state=INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_TWITTER_POST_SUCCCESS:
     
      
      return { ...state, posts: action.payload.data, errors: null }
    default:
      return state;
  }
}